module.exports = __webpack_public_path__ + "img/class-image-2.png";